import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const META = {
  agent: { title: "MyCompass - Agent Portal", appName: "MyCompass", icon: "/images/icon-mycompass-192.png", manifest: "/manifest-agent.json", theme: "#002363" },
  client: { title: "MyTrip - Client Portal", appName: "MyTrip", icon: "/images/icon-mytrip-192.png", manifest: "/manifest-client.json", theme: "#022455" },
  default: { title: "Topsail Travel | Travel Agency", appName: "Topsail Travel", icon: "/images/favicon-topsail.png", manifest: "/manifest.json", theme: "#0B192C" },
};

export default function DocumentMeta() {
  const { pathname } = useLocation();

  useEffect(() => {
    const meta = pathname.startsWith("/agent") ? META.agent
      : pathname.startsWith("/mytrip") ? META.client
      : META.default;

    document.title = meta.title;
    document.querySelectorAll("link[rel='icon'], link[rel='apple-touch-icon']").forEach((link) => {
      link.href = meta.icon;
    });
    const manifestLink = document.querySelector("link[rel='manifest']");
    if (manifestLink) manifestLink.href = meta.manifest;
    const themeMeta = document.querySelector("meta[name='theme-color']");
    if (themeMeta) themeMeta.content = meta.theme;
    ["apple-mobile-web-app-title", "application-name"].forEach((name) => {
      const el = document.querySelector(`meta[name='${name}']`);
      if (el) el.content = meta.appName;
    });
  }, [pathname]);

  return null;
}
